const Marketplace = () => import('@/modules/marketplace/views/Marketplace.vue')
const Integration = () => import('@/modules/marketplace/views/Integration.vue')
const Billing = () => import('@/modules/marketplace/views/Billing.vue')
const FinanceLinks = () => import('@/modules/marketplace/views/FinanceLinks.vue')
const SpecialPayment = () => import('@/modules/marketplace/views/SpecialPayment.vue')
import {
    marketplaceProjectRouteGuard,
    marketplaceUnauthorizedRouteGuard,
    billingManagerRouteGuard,
} from '@/modules/marketplace/marketplaceRouteGuards'

export default [
    {
        path: '/project/:id/marketplace',
        name: 'marketplace',
        component: Marketplace,
        unprotected: false,
        beforeEnter: marketplaceProjectRouteGuard,
    },
    {
        path: '/project/:id/marketplace/integration/:integrationId',
        name: 'marketplaceIntegration',
        component: Integration,
        unprotected: false,
        beforeEnter: marketplaceProjectRouteGuard,
    },
    {
        path: '/marketplace',
        name: 'marketplaceUnauthorized',
        component: Marketplace,
        unprotected: true,
        beforeEnter: marketplaceUnauthorizedRouteGuard,
    },
    {
        path: '/marketplace/integration/:integrationId',
        name: 'marketplaceIntegrationUnauthorized',
        component: Integration,
        unprotected: true,
        beforeEnter: marketplaceUnauthorizedRouteGuard,
    },
    {
        path: '/project/:id/billing/',
        alias: '/project/:id/billing',
        name: 'Billing',
        component: Billing,
        unprotected: false,
    },
    {
        path: '/project/:id/finances',
        name: 'FinanceLinks',
        component: FinanceLinks,
        unprotected: false,
        beforeEnter: billingManagerRouteGuard,
    },
    {
        path: '/project/:id/payment/:paymentPayloadId',
        name: 'SpecialPayment',
        component: SpecialPayment,
        unprotected: false,
    },
]
